import React from 'react';
import { Check } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function NinetyDayMap() {
  return <section className="bg-warm-white py-16 md:py-[100px] px-4 md:px-5" data-id="element-373">
      <div className="max-w-[1040px] mx-auto" data-id="element-374">
        <div className="text-center mb-10 md:mb-16" data-id="element-375">
          <h2 className="font-serif text-[30px] md:text-[44px] text-primary-dark mb-3 md:mb-4 leading-tight" data-id="element-376">
            Your Next 90 Days — Mapped
          </h2>
          <p className="font-sans text-[15px] md:text-[17px] text-primary-dark/60 max-w-[500px] mx-auto" data-id="element-377">
            Not vague advice. A specific sequence. Tools at every step. Starting
            Sunday.
          </p>
        </div>

        {/* Script + phone call visual */}
        <div className="mb-10 md:mb-16 max-w-[680px] mx-auto rounded-xl overflow-hidden shadow-[0_8px_30px_rgba(0,0,0,0.1)]" data-id="element-378">
          <img src="https://cdn.magicpatterns.com/uploads/rYQJXVWkZ4NTCJzhbDfQR3/heylloyd-image-1774831023706.png" alt="Making the 12-minute negotiation call with the word-for-word script — Phase 2 of the system" className="w-full h-auto block" data-id="element-379" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-8" data-id="element-380">
          {/* Phase 1 */}
          <div className="bg-white border border-black/5 border-t-[4px] border-t-gold-accent rounded-xl p-6 md:p-[40px_32px] shadow-[0_4px_20px_rgba(0,0,0,0.06)] flex flex-col" data-id="element-381">
            <span className="font-sans text-[11px] font-bold text-gold-accent uppercase tracking-widest mb-3 md:mb-4" data-id="element-382">
              PHASE 1 · DAYS 1–7
            </span>
            <h3 className="font-serif text-[24px] md:text-[28px] text-primary-dark mb-4 md:mb-6" data-id="element-383">
              SEE Your Money
            </h3>
            <p className="font-sans text-[15px] md:text-[16px] text-primary-dark/80 leading-relaxed mb-6 md:mb-8 flex-grow" data-id="element-384">
              You can't fix what you can't see.
              <br data-id="element-385" />
              <br data-id="element-386" />
              In 7 days — about 2 hours total — you'll know your exact debt
              number to the dollar, where every dollar of your income currently
              goes, and what a budget that works looks like for YOUR income.
              <br data-id="element-387" />
              <br data-id="element-388" />
              Not a template. Your actual numbers.
            </p>
            <ul className="space-y-2.5 md:space-y-3 font-sans text-[13px] md:text-[14px] text-primary-dark/60" data-id="element-389">
              {['Debt Snapshot Worksheet', '30-Day Money Map', 'Ghost Subscription Audit', 'Budget Reset Template'].map((item, i) => <li key={i} className="flex items-start" data-id="element-390">
                  <Check className="w-4 h-4 text-gold-accent mr-2.5 md:mr-3 mt-0.5 flex-shrink-0" data-id="element-391" />
                  <span data-id="element-392">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Phase 2 */}
          <div className="bg-white border-[3px] border-gold-accent rounded-xl p-6 md:p-[40px_32px] shadow-[0_8px_30px_rgba(212,168,73,0.15)] flex flex-col relative mt-4 lg:mt-0 lg:-translate-y-4" data-id="element-393">
            <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 bg-gold-accent text-primary-dark text-[9px] md:text-[10px] font-bold uppercase tracking-wider px-3 md:px-4 py-1 md:py-1.5 rounded-full whitespace-nowrap" data-id="element-394">
              THE PHASE THAT CHANGES EVERYTHING
            </div>
            <span className="font-sans text-[11px] font-bold text-gold-accent uppercase tracking-widest mb-3 md:mb-4 mt-2" data-id="element-395">
              PHASE 2 · DAYS 8–60 ⭐
            </span>
            <h3 className="font-serif text-[24px] md:text-[28px] text-primary-dark mb-4 md:mb-6" data-id="element-396">
              ATTACK Your Debt
            </h3>
            <p className="font-sans text-[15px] md:text-[16px] text-primary-dark/80 leading-relaxed mb-6 md:mb-8 flex-grow" data-id="element-397">
              This is where the system separates from every other debt book.
              <br data-id="element-398" />
              <br data-id="element-399" />
              You'll choose your debt elimination method and get a pre-built
              planner that shows the exact DATE each debt disappears.
              <br data-id="element-400" />
              <br data-id="element-401" />
              You'll make ONE phone call — using a word-for-word script — and
              likely save $50–$100 per month starting that same afternoon.
              <br data-id="element-402" />
              <br data-id="element-403" />
              You'll find $200–$500 hiding in your current spending using the
              Money Finder Checklist.
              <br data-id="element-404" />
              <br data-id="element-405" />
              And you'll build the Sunday Check-In — a 15-minute weekly ritual
              that replaces Sunday dread with something that actually feels like
              control.
            </p>
            <ul className="space-y-2.5 md:space-y-3 font-sans text-[13px] md:text-[14px] text-primary-dark/60" data-id="element-406">
              {['Debt Attack Planner (Snowball/Avalanche/Hybrid)', '3 Negotiation Scripts + Rebuttals', 'ROI Calculator + Call Tracker', 'Money Finder Checklist', '4 Bill Renegotiation Scripts', 'Sunday Check-In Template'].map((item, i) => <li key={i} className="flex items-start" data-id="element-407">
                  <Check className="w-4 h-4 text-gold-accent mr-2.5 md:mr-3 mt-0.5 flex-shrink-0" data-id="element-408" />
                  <span data-id="element-409">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Phase 3 */}
          <div className="bg-white border border-black/5 border-t-[4px] border-t-success-green rounded-xl p-6 md:p-[40px_32px] shadow-[0_4px_20px_rgba(0,0,0,0.06)] flex flex-col" data-id="element-410">
            <span className="font-sans text-[11px] font-bold text-success-green uppercase tracking-widest mb-3 md:mb-4" data-id="element-411">
              PHASE 3 · DAYS 61–90
            </span>
            <h3 className="font-serif text-[24px] md:text-[28px] text-primary-dark mb-4 md:mb-6" data-id="element-412">
              BUILD the Wall
            </h3>
            <p className="font-sans text-[15px] md:text-[16px] text-primary-dark/80 leading-relaxed mb-6 md:mb-8 flex-grow" data-id="element-413">
              Debt freedom without a wall is just a head start before the next
              emergency tears it down.
              <br data-id="element-414" />
              <br data-id="element-415" />
              Phase 3 builds the wall.
              <br data-id="element-416" />
              <br data-id="element-417" />
              A $1,000 Emergency Shield that means one car repair, one medical
              bill, one bad month — NEVER puts you back in debt again.
              <br data-id="element-418" />
              <br data-id="element-419" />
              A 3-account automation system that makes the right financial
              decisions without requiring your willpower.
              <br data-id="element-420" />
              <br data-id="element-421" />
              And your first real steps toward the thing that comes after debt:
              building actual wealth.
            </p>
            <ul className="space-y-2.5 md:space-y-3 font-sans text-[13px] md:text-[14px] text-primary-dark/60" data-id="element-422">
              {['Emergency Sprint Tracker', '3-Account Automation Blueprint', 'Wealth Starter Kit', 'Quick Reference Card (the system on one page)'].map((item, i) => <li key={i} className="flex items-start" data-id="element-423">
                  <Check className="w-4 h-4 text-gold-accent mr-2.5 md:mr-3 mt-0.5 flex-shrink-0" data-id="element-424" />
                  <span data-id="element-425">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="flex justify-center mt-10 md:mt-16" data-id="element-426">
          <CTAButton subText="Phase 1 starts this Sunday · 15 minutes" data-id="element-427">
            START MY 90 DAYS — $9.99
          </CTAButton>
        </div>
      </div>
    </section>;
}